<template>
  <CustomDeleteDialog
    dialogTitle="حذف مسدودی کاربر"
    dialogId="remove-user-from-blocklist"
    okTitle="حذف مسدودی کاربر"
    no-close-on-backdrop
    :isOkDisabled="isOkButtonDisabled || !studentId"
    @ok="sendUnBlockRequest"
  >
    <BCol cols="12">
      <p>آیا از حذف مسدودی این کاربر اطمینان دارید؟</p>
    </BCol>
  </CustomDeleteDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    studentId: {
      type: [Number, String],
      required: false,
    },
  },
  data() {
    return {
      unBlockUserPayload: {
        masterId: null,
        studentId: null,
      },
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async sendUnBlockRequest() {
      try {
        if (this.studentId) {
          this.unBlockUserPayload.studentId = this.studentId;
        }
        if (getUserData() && getUserData().user && getUserData().user.userId) {
          this.unBlockUserPayload.masterId = getUserData().user.userId;
        }
        this.isOkButtonDisabled = true;
        let _this = this;
        let unblockUserByMaster = new UnblockUserByMaster(_this);
        unblockUserByMaster.setRequestParam(_this.unBlockUserPayload);
        await unblockUserByMaster.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "کاربر با موفقیت از لیست مسدودی حذف شد.",
              },
            });
            _this.unBlockUserPayload = {
              masterId: null,
              studentId: null,
            };
            this.$bvModal.hide("remove-user-from-blocklist");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    BCol,
    CustomDeleteDialog,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { UnblockUserByMaster } from "@/libs/Api/Users";
import { BCol } from "bootstrap-vue";
import { getUserData } from "@/auth/utils";
</script>
